export type BorderRadius =
  | {
      borderTopLeftRadius: number;
      borderTopRightRadius: number;
      borderBottomLeftRadius: number;
      borderBottomRightRadius: number;
    }
  | { borderRadius: number };

export const getBorderRadius = (
  itemIndex: number,
  totalLength: number
): BorderRadius => {
  const isFirstInGroup = itemIndex === 0;
  const isLastInGroup = itemIndex === totalLength - 1;

  if (isFirstInGroup && isLastInGroup) {
    return {
      borderTopLeftRadius: 16,
      borderTopRightRadius: 16,
      borderBottomLeftRadius: 16,
      borderBottomRightRadius: 16
    };
  }
  if (isFirstInGroup) {
    return {
      borderTopLeftRadius: 16,
      borderTopRightRadius: 16,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0
    };
  }
  if (isLastInGroup) {
    return {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderBottomLeftRadius: 16,
      borderBottomRightRadius: 16
    };
  }
  return { borderRadius: 0 };
};
